import React from 'react';

interface EmptyStateProps {
  icon: React.ReactNode;
  title: string;
  subtitle: string;
  action?: { label: string; onClick: () => void };
  positive?: boolean;
}

export const EmptyState: React.FC<EmptyStateProps> = ({ icon, title, subtitle, action, positive }) => (
  <div className="flex flex-col items-center justify-center py-12 px-4">
    <div className={`w-10 h-10 flex items-center justify-center ${positive ? 'text-emerald-400' : 'text-slate-300'}`}>
      {icon}
    </div>
    <h3 className={`font-medium mt-3 ${positive ? 'text-emerald-600' : 'text-slate-600'}`}>{title}</h3>
    <p className="text-slate-400 text-sm mt-1 max-w-md mx-auto text-center">{subtitle}</p>
    {action && (
      <button
        onClick={action.onClick}
        className="mt-4 px-4 py-2 bg-indigo-600 text-white text-sm font-medium rounded-lg hover:bg-indigo-700 transition-colors"
      >
        {action.label}
      </button>
    )}
  </div>
);
